import { useTranslation } from 'react-i18next';
import React from 'react';
import PropTypes from 'prop-types';
import DetailsRow from './DetailsRow';

const Bankruptcy = ({ bankruptcy }) => {
  const { t } = useTranslation();
  return (
    <div>
      {bankruptcy?.events.map((event, index) => {
        return (
          <table style={{ marginBottom: '16px' }} key={index}>
            {event.date && <DetailsRow label={t(`onboard.customer.singleView.credit.date`)} value={event.date} />}
            {event.description && (
              <DetailsRow label={t(`onboard.customer.singleView.credit.description`)} value={event.description} />
            )}
          </table>
        );
      })}
    </div>
  );
};

Bankruptcy.propTypes = {
  bankruptcy: PropTypes.shape({
    events: PropTypes.arrayOf(
      PropTypes.shape({
        date: PropTypes.string,
        description: PropTypes.string,
      }),
    ),
  }),
};

export default Bankruptcy;
